var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhoweare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 441.809,
    height: 427.222,
    viewBox: "0 0 441.809 427.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 441.809,
    height: 427.222,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whoweare",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "why-us",
    transform: "translate(-29.871 -38.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M111.948,232.314l3.7,7.505a1.3,1.3,0,0,0,.978.711l8.283,1.2a1.3,1.3,0,0,1,.72,2.216l-5.993,5.842a1.3,1.3,0,0,0-.374,1.15l1.415,8.249a1.3,1.3,0,0,1-1.885,1.369l-7.408-3.894a1.3,1.3,0,0,0-1.209,0l-7.409,3.894a1.3,1.3,0,0,1-1.885-1.369l1.415-8.249a1.3,1.3,0,0,0-.374-1.15l-5.993-5.842a1.3,1.3,0,0,1,.72-2.216l8.283-1.2a1.3,1.3,0,0,0,.978-.711l3.7-7.505A1.3,1.3,0,0,1,111.948,232.314Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M78.078,188.93l2.562,5.192a.9.9,0,0,0,.677.491l5.73.833a.9.9,0,0,1,.5,1.533L83.4,201.021a.9.9,0,0,0-.259.795l.979,5.707a.9.9,0,0,1-1.3.947l-5.125-2.694a.9.9,0,0,0-.836,0l-5.125,2.694a.9.9,0,0,1-1.3-.947l.978-5.707a.9.9,0,0,0-.258-.795L67,196.979a.9.9,0,0,1,.5-1.533l5.73-.833a.894.894,0,0,0,.676-.491l2.563-5.192A.9.9,0,0,1,78.078,188.93Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M263.477,54.767l1.776,3.6a.622.622,0,0,0,.469.341l3.971.577a.623.623,0,0,1,.345,1.063l-2.873,2.8a.621.621,0,0,0-.179.551l.678,3.955a.623.623,0,0,1-.9.656l-3.551-1.867a.626.626,0,0,0-.58,0l-3.552,1.867a.622.622,0,0,1-.9-.656l.678-3.955a.621.621,0,0,0-.179-.551l-2.874-2.8a.624.624,0,0,1,.346-1.063l3.971-.577a.624.624,0,0,0,.469-.341l1.775-3.6A.623.623,0,0,1,263.477,54.767Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M418.522,240.266l1.776,3.6a.621.621,0,0,0,.469.34l3.971.577a.623.623,0,0,1,.345,1.063l-2.874,2.8a.626.626,0,0,0-.179.551l.679,3.955a.623.623,0,0,1-.9.656l-3.552-1.867a.624.624,0,0,0-.579,0l-3.552,1.867a.623.623,0,0,1-.9-.656l.678-3.955a.621.621,0,0,0-.179-.551l-2.873-2.8a.623.623,0,0,1,.345-1.063l3.971-.577a.623.623,0,0,0,.469-.34l1.776-3.6A.623.623,0,0,1,418.522,240.266Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M377.466,223.692l2.929,5.936a1.03,1.03,0,0,0,.774.562l6.55.952a1.027,1.027,0,0,1,.57,1.752l-4.74,4.62a1.028,1.028,0,0,0-.3.91l1.119,6.524a1.028,1.028,0,0,1-1.491,1.083l-5.858-3.08a1.025,1.025,0,0,0-.957,0l-5.858,3.08a1.028,1.028,0,0,1-1.491-1.083l1.119-6.524a1.031,1.031,0,0,0-.3-.91l-4.74-4.62a1.027,1.027,0,0,1,.57-1.752l6.55-.952a1.029,1.029,0,0,0,.774-.562l2.929-5.936A1.028,1.028,0,0,1,377.466,223.692Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M78.838,296.218l2.113,4.282a.741.741,0,0,0,.558.4l4.726.687a.741.741,0,0,1,.41,1.264l-3.419,3.333a.74.74,0,0,0-.213.656l.807,4.706a.741.741,0,0,1-1.075.781l-4.227-2.222a.743.743,0,0,0-.689,0L73.6,312.332a.741.741,0,0,1-1.075-.781l.807-4.706a.74.74,0,0,0-.213-.656L69.7,302.856a.741.741,0,0,1,.41-1.264l4.726-.687a.741.741,0,0,0,.558-.4l2.113-4.282A.741.741,0,0,1,78.838,296.218Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 11.479,
    height: 57.117,
    transform: "translate(168.004 59.702) rotate(-0.307)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_802",
    "data-name": "Group 802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_801",
    "data-name": "Group 801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_800",
    "data-name": "Group 800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 29.725,
    height: 31.533,
    transform: "translate(68.562 59.948) rotate(-0.306)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_806",
    "data-name": "Group 806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_805",
    "data-name": "Group 805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_804",
    "data-name": "Group 804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_803",
    "data-name": "Group 803"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 29.725,
    height: 31.532,
    transform: "translate(98.146 59.79) rotate(-0.307)",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_813",
    "data-name": "Group 813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_811",
    "data-name": "Group 811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_810",
    "data-name": "Group 810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M68.608,68.657c19.754.163,39.558.048,59.31-.273a.316.316,0,0,0,0-.631c-19.754-.11-39.557-.013-59.308.362a.271.271,0,0,0,0,.542Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_819",
    "data-name": "Group 819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    "data-name": "Group 818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_817",
    "data-name": "Group 817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_816",
    "data-name": "Group 816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_815",
    "data-name": "Group 815"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 54.006,
    height: 25.697,
    transform: "matrix(1, -0.005, 0.005, 1, 50.029, 91.085)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_823",
    "data-name": "Group 823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    "data-name": "Group 822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_821",
    "data-name": "Group 821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    "data-name": "Group 820"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 54.006,
    height: 25.696,
    transform: "matrix(1, -0.005, 0.005, 1, 103.779, 90.797)",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_826",
    "data-name": "Group 826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M50.067,98.231c35.877.407,71.88.042,107.756-.532a.316.316,0,0,0,0-.631c-35.879-.19-71.884-.169-107.755.622a.271.271,0,0,0,0,.541Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    "data-name": "Group 844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_835",
    "data-name": "Group 835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    "data-name": "Group 834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 209.235,
    height: 9.206,
    transform: "translate(29.871 116.781)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_839",
    "data-name": "Group 839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    "data-name": "Group 838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 8.494,
    height: 31.412,
    transform: "translate(64.127 121.207)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    "data-name": "Group 843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_842",
    "data-name": "Group 842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_840",
    "data-name": "Group 840"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 8.494,
    height: 31.412,
    transform: "translate(190.923 121.207)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_847",
    "data-name": "Group 847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 11.479,
    height: 78.556,
    transform: "translate(179.205 38.403) rotate(-0.307)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_854",
    "data-name": "Group 854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_852",
    "data-name": "Group 852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 17.836,
    height: 63.661,
    transform: "translate(190.783 53.06) rotate(-0.307)",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_855",
    "data-name": "Group 855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M208.5,65.229c0,.171-3.993.309-8.918.309s-8.918-.138-8.918-.309,3.992-.309,8.918-.309S208.5,65.059,208.5,65.229Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_862",
    "data-name": "Group 862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_860",
    "data-name": "Group 860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M208.5,62.555c0,.17-3.993.309-8.918.309s-8.918-.139-8.918-.309,3.992-.309,8.918-.309S208.5,62.384,208.5,62.555Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_867",
    "data-name": "Group 867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_866",
    "data-name": "Group 866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M208.5,107.047c0,.17-3.993.309-8.918.309s-8.918-.139-8.918-.309,3.992-.309,8.918-.309S208.5,106.876,208.5,107.047Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_874",
    "data-name": "Group 874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_873",
    "data-name": "Group 873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_870",
    "data-name": "Group 870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M208.5,104.372c0,.171-3.993.309-8.918.309s-8.918-.138-8.918-.309,3.992-.309,8.918-.309S208.5,104.2,208.5,104.372Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_879",
    "data-name": "Group 879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_878",
    "data-name": "Group 878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_877",
    "data-name": "Group 877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_876",
    "data-name": "Group 876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_875",
    "data-name": "Group 875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M199.868,98.537c-.171,0-.309-6.422-.309-14.343s.138-14.345.309-14.345.309,6.421.309,14.345S200.039,98.537,199.868,98.537Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 19.414,
    height: 48.051,
    transform: "translate(208.692 68.598)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M188.075,51.754a3.3,3.3,0,1,1-3.3-3.3A3.3,3.3,0,0,1,188.075,51.754Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 2.039,
    height: 46.731,
    transform: "translate(183.756 60.827)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 141.141,
    height: 126.273,
    transform: "translate(317.385 77.408)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M458.526,203.68s-.024-.809-.036-2.343c-.009-1.55-.021-3.815-.037-6.766-.019-5.929-.047-14.594-.083-25.632-.039-22.063-.1-53.589-.164-91.531l.319.32L317.4,77.785h-.013l.377-.377c-.016,45.94-.032,89.168-.045,126.272l-.332-.332,102.083.168,28.792.087,7.623.039,1.965.019c.443.007.678.019.678.019s-.21.013-.64.019l-1.93.019-7.557.039-28.717.088-102.3.167h-.332v-.333c-.013-37.1-.029-80.332-.045-126.272v-.377h.39l141.127.057h.321v.32c-.069,38.026-.125,69.622-.165,91.734-.036,11.006-.064,19.648-.083,25.56-.016,2.924-.028,5.169-.037,6.7C458.549,202.918,458.526,203.68,458.526,203.68Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M371.5,99.844c0,.208-7.429.377-16.59.377s-16.593-.169-16.593-.377,7.427-.377,16.593-.377S371.5,99.636,371.5,99.844Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M431.307,109.325c0,.208-20.409.377-45.58.377s-45.584-.169-45.584-.377,20.4-.377,45.584-.377S431.307,109.117,431.307,109.325Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 5.946,
    height: 5.946,
    transform: "translate(338.563 125.385)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 5.946,
    height: 5.946,
    transform: "translate(353.2 125.385)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 5.946,
    height: 5.946,
    transform: "translate(368.107 125.115)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 5.946,
    height: 5.946,
    transform: "translate(382.474 125.385)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 5.946,
    height: 5.946,
    transform: "translate(397.11 125.385)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 5.946,
    height: 5.946,
    transform: "translate(411.747 125.385)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_920",
    "data-name": "Group 920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 5.946,
    height: 5.946,
    transform: "translate(426.384 125.385)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_922",
    "data-name": "Group 922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_921",
    "data-name": "Group 921"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 5.946,
    height: 5.946,
    transform: "translate(338.563 138.027)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_923",
    "data-name": "Group 923"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 5.946,
    height: 5.946,
    transform: "translate(353.2 138.027)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 5.946,
    height: 5.946,
    transform: "translate(367.837 138.027)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 5.946,
    height: 5.946,
    transform: "translate(382.474 138.027)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 5.946,
    height: 5.946,
    transform: "translate(397.11 138.027)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 5.946,
    height: 5.946,
    transform: "translate(412.017 137.756)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 5.946,
    height: 5.946,
    transform: "translate(426.384 138.027)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 5.946,
    height: 5.946,
    transform: "translate(338.563 150.668)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 5.946,
    height: 5.946,
    transform: "translate(353.47 150.398)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 5.946,
    height: 5.946,
    transform: "translate(367.837 150.668)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 5.946,
    height: 5.946,
    transform: "translate(382.474 150.668)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 5.946,
    height: 5.946,
    transform: "translate(397.11 150.668)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 5.946,
    height: 5.946,
    transform: "translate(411.747 150.668)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 5.946,
    height: 5.946,
    transform: "translate(426.384 150.668)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 5.946,
    height: 5.946,
    transform: "translate(338.563 163.309)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_952",
    "data-name": "Group 952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    "data-name": "Group 951"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 5.946,
    height: 5.946,
    transform: "translate(353.2 163.309)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    "data-name": "Group 954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    "data-name": "Group 953"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 5.946,
    height: 5.946,
    transform: "translate(367.837 163.309)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_955",
    "data-name": "Group 955"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 5.946,
    height: 5.946,
    transform: "translate(382.743 163.039)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    "data-name": "Group 957"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 5.946,
    height: 5.946,
    transform: "translate(397.11 163.309)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 5.946,
    height: 5.946,
    transform: "translate(411.747 163.309)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 5.946,
    height: 5.946,
    transform: "translate(426.384 163.309)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 5.946,
    height: 5.946,
    transform: "translate(338.563 175.95)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 5.946,
    height: 5.946,
    transform: "translate(353.2 175.95)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 5.946,
    height: 5.946,
    transform: "translate(367.837 175.95)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 5.946,
    height: 5.946,
    transform: "translate(382.474 175.95)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 5.946,
    height: 5.946,
    transform: "translate(397.11 175.95)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 5.946,
    height: 5.946,
    transform: "translate(412.017 175.68)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 5.946,
    height: 5.946,
    transform: "translate(426.384 175.95)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M48.49,399.648v36.768H42.351v3.991H48.49v24.608H163.242V442.624h-8.5v-4.877h8.5v-7.316h3.778v-3.326h-4.487V399.648Z",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M132.769,399.755v64.85h30.473V442.214h-8.5v-4.468l8.5.151v-7.316l3.851,0-.074-3.781-4.486-.11V399.648Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M134.94,439.879c0,.225-20.765.407-46.373.407s-46.378-.182-46.378-.407,20.761-.408,46.378-.408S134.94,439.654,134.94,439.879Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_991",
    "data-name": "Group 991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    "data-name": "Group 990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M134.94,436.144c0,.225-20.765.408-46.373.408s-46.378-.183-46.378-.408,20.761-.407,46.378-.407S134.94,435.919,134.94,436.144Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_992",
    "data-name": "Group 992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M140.9,426.092c0,.226-20.765.408-46.373.408s-46.378-.182-46.378-.408,20.76-.407,46.378-.407S140.9,425.868,140.9,426.092Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M141.47,453.483c0,.226-20.765.408-46.374.408s-46.377-.182-46.377-.408,20.76-.407,46.377-.407S141.47,453.258,141.47,453.483Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M63.379,338.385v34.846H57.561v3.782h5.818v23.322H172.132V379.114h-8.056v-4.622h8.056v-6.934h3.58v-3.152h-4.251V338.385Z",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M143.252,338.486v61.46h28.88V378.726h-8.056v-4.234l8.056.143V367.7l3.65,0-.07-3.583-4.251-.1V338.385Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M145.31,376.512c0,.214-19.68.387-43.949.387s-43.954-.173-43.954-.387,19.675-.386,43.954-.386S145.31,376.3,145.31,376.512Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M145.31,372.973c0,.213-19.68.386-43.949.386s-43.954-.173-43.954-.386,19.675-.386,43.954-.386S145.31,372.76,145.31,372.973Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M150.955,363.447c0,.213-19.679.386-43.949.386s-43.953-.173-43.953-.386,19.675-.387,43.953-.387S150.955,363.234,150.955,363.447Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M151.5,389.406c0,.213-19.679.386-43.949.386s-43.954-.173-43.954-.386,19.675-.386,43.954-.386S151.5,389.193,151.5,389.406Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M395.176,353.565c-5.948-3.069-12.952-3.468-19.556-2.377-3.547.587-7.246,1.648-9.66,4.313s-2.871,7.354-.1,9.644c1.65,1.363,3.952,1.57,6.092,1.546,5.169-.061,10.9-.971,15.035,2.139,2.356,1.775,3.924,4.725,6.742,5.6,2.756.854,5.866-.773,7.327-3.26a11.384,11.384,0,0,0,.829-8.4A12.823,12.823,0,0,0,395.176,353.565Z",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M408.8,327.258c-3.637,5.2-10.706,3.475-13.984.3s-4.663-7.766-5.924-12.149c-2.881-10.013-5.786-20.517-3.644-30.714a17.077,17.077,0,0,1,3.923-8.35,8.916,8.916,0,0,1,8.448-2.811c3.564.941,5.78,4.432,7.38,7.753a73.195,73.195,0,0,1,7.235,31.42c.018,5.061-.579,10.369-3.434,14.547",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M418.791,334.712c-3.949-4.687-4.7-11.523-2.941-17.4s5.728-10.866,10.3-14.944A55.459,55.459,0,0,1,444.6,291.488a19.665,19.665,0,0,1,8.3-1.41,8.709,8.709,0,0,1,6.963,4.213c1.941,3.7.08,8.194-1.934,11.858A140.456,140.456,0,0,1,445.81,324.6c-3.631,4.682-7.792,9.3-13.327,11.418s-11.285,1.867-14.219-1.972",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M409.05,405.62a11.3,11.3,0,0,1-.329-2.361c-.168-1.718-.377-3.875-.627-6.442a93.05,93.05,0,0,0-1.449-9.449,72.962,72.962,0,0,0-3.435-11.152,41.1,41.1,0,0,0-5.695-10.091,21.272,21.272,0,0,0-7.2-5.985,20.123,20.123,0,0,0-6.063-1.888,11.47,11.47,0,0,1-2.351-.34,10.945,10.945,0,0,1,2.392-.037,18.35,18.35,0,0,1,6.322,1.645,21.214,21.214,0,0,1,7.6,6.038,40.157,40.157,0,0,1,5.9,10.293,68.252,68.252,0,0,1,3.41,11.335,79.827,79.827,0,0,1,1.256,9.568c.2,2.736.282,4.951.319,6.482A11.149,11.149,0,0,1,409.05,405.62Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M408.606,400.663a4.622,4.622,0,0,1-.064-1.1c0-.823.005-1.859.009-3.132.007-2.718.006-6.652-.14-11.509-.24-9.714-1.077-20.17-2.692-34.91-1.53-13.86-3.584-29.991-5.751-40.478-.464-2.385-.932-4.532-1.373-6.411-.42-1.884-.779-3.508-1.125-4.822-.3-1.237-.539-2.244-.732-3.044a4.716,4.716,0,0,1-.192-1.081,4.548,4.548,0,0,1,.381,1.027l.909,3c.4,1.3.817,2.916,1.289,4.792.492,1.872,1.008,4.013,1.517,6.395a355.429,355.429,0,0,1,6.045,37.559c1.619,14.771,2.348,28.22,2.413,37.959.058,4.87-.046,8.812-.17,11.532-.078,1.272-.141,2.308-.191,3.13A4.7,4.7,0,0,1,408.606,400.663Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M408.541,374.723a20.746,20.746,0,0,1,.023-3.272c.12-2.1.409-5.142,1-8.864a116.671,116.671,0,0,1,2.883-12.915,105.738,105.738,0,0,1,5.4-15.282c4.48-10.627,10.566-19.315,15.86-24.7a40.28,40.28,0,0,1,3.732-3.468c.572-.484,1.078-.967,1.593-1.349l1.448-1a20.92,20.92,0,0,1,2.754-1.763c.157.212-3.9,2.6-9.028,8.055a85.78,85.78,0,0,0-15.465,24.607,120.945,120.945,0,0,0-5.431,15.141c-1.416,4.745-2.357,9.11-3.068,12.787-.675,3.685-1.066,6.694-1.3,8.777A21.169,21.169,0,0,1,408.541,374.723Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M433.613,420.481l-2.6,35.61H385.267l-2.6-35.61Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 60.823,
    height: 14.036,
    transform: "translate(377.209 406.445)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M438.032,454.728v3.891H378.214v-3.891Z",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M432.373,465.467l2.8-6.848H380.393l3.268,6.848Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    "data-name": "Group 1050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M383.517,432.119a1.405,1.405,0,0,0,.213.327c.182.241.406.54.684.907l2.665,3.41.118.152.115-.159,6.547-9.055h-.377l6.446,9.127.2.287.226-.269,7.644-9.1-.44-.006.42.529,6.836,8.57.228.285.21-.3,6.449-9.125-.375.017,7.943,9.05.141.161.108-.181c1.047-1.759,1.881-3.162,2.487-4.178.26-.454.47-.821.638-1.113a1.689,1.689,0,0,0,.194-.4,1.826,1.826,0,0,0-.266.353l-.706,1.07c-.635,1-1.512,2.376-2.611,4.1l.249-.02c-2.036-2.385-4.688-5.494-7.815-9.159l-.2-.231-.178.249c-1.978,2.761-4.165,5.815-6.507,9.083l.438-.011-6.819-8.583-.421-.528-.217-.273-.224.267-7.623,9.114.428.017-6.511-9.082-.191-.266-.186.266-6.409,9.154.233-.007-2.772-3.324-.743-.859A1.506,1.506,0,0,0,383.517,432.119Z",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M382.031,420.246c0,.157,11.463.285,25.6.285s25.6-.128,25.6-.285-11.46-.285-25.6-.285S382.031,420.089,382.031,420.246Z",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1057",
    "data-name": "Group 1057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M379.72,459c0,.157,12.457.285,27.821.285s27.825-.128,27.825-.285-12.455-.285-27.825-.285S379.72,458.845,379.72,459Z",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M448.064,465.3c0,.144-88.683.261-198.055.261-109.409,0-198.073-.117-198.073-.261s88.664-.26,198.073-.26C359.381,465.043,448.064,465.159,448.064,465.3Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_2",
    "data-name": "Character 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1248",
    "data-name": "Group 1248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1241",
    "data-name": "Group 1241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1230",
    "data-name": "Group 1230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1064",
    "data-name": "Group 1064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M267.494,93.594c.426-7.515,5.047-12.137,11.522-15.974a23.48,23.48,0,0,1,21.668-.983c4.544,2.164,8.523,5.86,13.516,6.5,8.221,1.06,16-6.557,24.071-4.655a10.693,10.693,0,0,1-.784,20.969c5.384.78,8.432,7.59,6.441,12.653s-7.641,8-13.08,8.118-10.666-2.1-15.371-4.833-9.1-6.015-14-8.363-10.552-3.72-15.809-2.321c-7.117,1.895-12.16,8.614-14.017,15.741s-1.055,14.655.05,21.937,2.508,14.625,1.817,21.958a2.732,2.732,0,0,1-1.03,2.264c-1.094.6-2.347-.43-3.152-1.385a108.078,108.078,0,0,1-20.317-36.8c-2.484-7.806-3.853-15.4-.872-23.033s13.027-14.893,19.351-11.792",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1079",
    "data-name": "Group 1079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    "data-name": "Group 1071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1068",
    "data-name": "Group 1068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M260.561,129.909l12.033,74.238c2.246,13.862,11.256,27.258,33.012,22.706h0c18.578-5.373,17.2-18.737,14.777-35.214h0s20.437-5.315,18.606-26.1c-.885-10.043-4.391-30.582-7.779-49.125a38.861,38.861,0,0,0-42.125-31.659l-2,.2C265.614,88.391,256.535,108.543,260.561,129.909Z",
    fill: "#ffbf9d"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1087",
    "data-name": "Group 1087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1085",
    "data-name": "Group 1085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M320.383,191.639s-13.006,2.083-27.829-5.272c0,0,8.15,15.44,28.674,11.488Z",
    fill: "#ff9a6c"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    "data-name": "Group 1169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1167",
    "data-name": "Group 1167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    "data-name": "Group 1108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1104",
    "data-name": "Group 1104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    "data-name": "Group 1103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1101",
    "data-name": "Group 1101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M324.169,137.207a2.98,2.98,0,0,1-2.558,3.278,2.85,2.85,0,0,1-3.324-2.365,2.98,2.98,0,0,1,2.554-3.28A2.852,2.852,0,0,1,324.169,137.207Z",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1115",
    "data-name": "Group 1115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M327.775,127.052c-.328.423-2.741-1.013-5.93-.684-3.19.283-5.366,2.16-5.751,1.8-.188-.156.116-.892,1.061-1.736a8.17,8.17,0,0,1,4.556-1.922,7.843,7.843,0,0,1,4.769,1.027C327.537,126.195,327.939,126.86,327.775,127.052Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1135",
    "data-name": "Group 1135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1132",
    "data-name": "Group 1132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1131",
    "data-name": "Group 1131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1130",
    "data-name": "Group 1130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1129",
    "data-name": "Group 1129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1128",
    "data-name": "Group 1128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1125",
    "data-name": "Group 1125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M294.283,139.118a2.979,2.979,0,0,1-2.558,3.277,2.849,2.849,0,0,1-3.324-2.365,2.981,2.981,0,0,1,2.555-3.279A2.85,2.85,0,0,1,294.283,139.118Z",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    "data-name": "Group 1144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1139",
    "data-name": "Group 1139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M296.481,130.8c-.329.424-2.745-1.012-5.932-.683-3.189.283-5.366,2.159-5.751,1.8-.187-.155.113-.89,1.062-1.735a8.177,8.177,0,0,1,4.555-1.923,7.861,7.861,0,0,1,4.77,1.027C296.239,129.942,296.643,130.608,296.481,130.8Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M310.436,153.291c-.034-.18,1.915-.722,5.086-1.455.807-.167,1.561-.406,1.642-.975a4.165,4.165,0,0,0-.786-2.36q-1.446-2.841-3.032-5.96c-4.234-8.495-7.385-15.512-7.042-15.68s4.054,6.582,8.287,15.076q1.536,3.146,2.935,6.008a4.738,4.738,0,0,1,.744,3.154,2.052,2.052,0,0,1-1.22,1.326,5.554,5.554,0,0,1-1.364.331C312.47,153.255,310.466,153.472,310.436,153.291Z",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M296.048,118.216c-.228.9-3.454.807-7.151,1.635-3.714.753-6.622,2.152-7.2,1.425-.259-.351.185-1.219,1.321-2.182a12.757,12.757,0,0,1,10.93-2.331C295.381,117.179,296.141,117.79,296.048,118.216Z",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M325.674,117.938c-.488.781-2.761.25-5.407.48-2.654.138-4.83.977-5.422.271-.262-.345.016-1.106.925-1.89a7.857,7.857,0,0,1,8.726-.605C325.505,116.844,325.886,117.559,325.674,117.938Z",
    fill: "#263238"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1213",
    "data-name": "Group 1213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1212",
    "data-name": "Group 1212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    "data-name": "Group 1211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1210",
    "data-name": "Group 1210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1209",
    "data-name": "Group 1209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1208",
    "data-name": "Group 1208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1207",
    "data-name": "Group 1207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    "data-name": "Group 1206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    "data-name": "Group 1205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    "data-name": "Group 1201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M263.8,145.108c-.37-.118-14.687-2.784-12.806,11.361s15.693,9.34,15.664,8.931S263.8,145.108,263.8,145.108Z",
    fill: "#ffbf9d"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1227",
    "data-name": "Group 1227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1226",
    "data-name": "Group 1226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1225",
    "data-name": "Group 1225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1224",
    "data-name": "Group 1224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1223",
    "data-name": "Group 1223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1222",
    "data-name": "Group 1222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1221",
    "data-name": "Group 1221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1220",
    "data-name": "Group 1220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1219",
    "data-name": "Group 1219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1218",
    "data-name": "Group 1218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1217",
    "data-name": "Group 1217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1216",
    "data-name": "Group 1216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1215",
    "data-name": "Group 1215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1214",
    "data-name": "Group 1214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M261.627,160.615c-.069-.037-.224.206-.615.452a2.489,2.489,0,0,1-1.837.283c-1.567-.351-3.141-2.556-3.548-5.1a8.216,8.216,0,0,1,.22-3.62,2.874,2.874,0,0,1,1.6-2.138,1.266,1.266,0,0,1,1.544.483c.242.37.19.664.268.679.044.03.272-.278.08-.847a1.586,1.586,0,0,0-.674-.812,1.875,1.875,0,0,0-1.411-.179,3.49,3.49,0,0,0-2.282,2.535,8.442,8.442,0,0,0-.331,4.056c.47,2.839,2.284,5.312,4.407,5.631a2.663,2.663,0,0,0,2.2-.674C261.647,160.961,261.679,160.634,261.627,160.615Z",
    fill: "#ff9a6c"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1229",
    "data-name": "Group 1229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M329.516,97.06c-2.257-3.893-5.878-6.823-9.723-9.163A46.478,46.478,0,0,0,292.012,81a37.844,37.844,0,0,0-25.406,12.636,39.959,39.959,0,0,0-8.9,21.158,58.675,58.675,0,0,0,2.178,23.033c.933,3.277,2.191,6.649,4.78,8.865,1.617,1.384,4.232,2.14,5.781.681a5.67,5.67,0,0,0,1.323-3.44c1.63-11.225,3.14-23.271-1.931-33.417a32.738,32.738,0,0,1,8.871-9.966,16.946,16.946,0,0,1,12.716-3.06c6.523,1.311,11.038,7.074,16.518,10.848a30.131,30.131,0,0,0,27.235,3.321Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1240",
    "data-name": "Group 1240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    "data-name": "Group 1233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1232",
    "data-name": "Group 1232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1231",
    "data-name": "Group 1231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M313.244,161.91a14.185,14.185,0,0,1-1.059,3.9,4.784,4.784,0,0,1-2.923,2.626,4.287,4.287,0,0,1-3.956-1.193,6.852,6.852,0,0,1-1.835-3.831c-.209-1.285.056-2.927,1.29-3.342a3.269,3.269,0,0,1,1.608.019l7.216,1.306",
    fill: "#ff9a6c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1239",
    "data-name": "Group 1239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    "data-name": "Group 1238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    "data-name": "Group 1237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1236",
    "data-name": "Group 1236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1235",
    "data-name": "Group 1235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M311.733,167.938c-.078-.2-1.414.7-3.639.3a5.183,5.183,0,0,1-3.192-1.876,5.46,5.46,0,0,1-1-4.333,4.871,4.871,0,0,1,.372-1.115c.206-.332.16-.309.456-.327.286.016.767.13,1.153.195l1.185.216c1.545.279,2.939.512,4.113.691,2.348.358,3.817.5,3.85.333s-1.376-.6-3.682-1.174c-1.152-.287-2.529-.608-4.061-.946l-1.178-.256a12.207,12.207,0,0,0-1.319-.247,1.6,1.6,0,0,0-.981.235,1.865,1.865,0,0,0-.612.734,5.81,5.81,0,0,0-.484,1.418,6.372,6.372,0,0,0,1.316,5.279,5.811,5.811,0,0,0,3.948,2.023,5.487,5.487,0,0,0,2.9-.491C311.51,168.289,311.772,168,311.733,167.938Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1242",
    "data-name": "Group 1242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M343.01,81.375a3.824,3.824,0,0,1,.28.93,9.493,9.493,0,0,1,.093,2.79,13.061,13.061,0,0,1-5.131,8.69c-3.48,2.761-8.983,3.872-14.653,3-5.745-.786-11.484-3.545-17.489-6.017-5.976-2.472-12.16-4.139-17.682-3.127a22.337,22.337,0,0,0-12.611,7.215,29.885,29.885,0,0,0-5.39,8.44c-.9,2.206-1.22,3.5-1.312,3.475a3.765,3.765,0,0,1,.176-.951,23.913,23.913,0,0,1,.8-2.657,28.347,28.347,0,0,1,5.238-8.744,22.728,22.728,0,0,1,12.952-7.619c5.771-1.1,12.152.619,18.176,3.111,6.054,2.5,11.7,5.227,17.266,6.03,5.5.886,10.781-.127,14.132-2.683a12.945,12.945,0,0,0,5.17-8.216A14.233,14.233,0,0,0,343.01,81.375Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1245",
    "data-name": "Group 1245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1244",
    "data-name": "Group 1244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M250.126,124.467a10.062,10.062,0,0,1,.553-3.909,24.339,24.339,0,0,1,4.292-8.518,24.075,24.075,0,0,1,3.681-3.792,8.894,8.894,0,0,1,3.88-2.035,4.715,4.715,0,0,1,2.954.333c.636.328.871.657.835.695a5.44,5.44,0,0,0-3.646-.389c-2.224.569-4.724,2.96-6.974,5.757a28.228,28.228,0,0,0-4.4,8.142C250.513,123.008,250.28,124.491,250.126,124.467Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1247",
    "data-name": "Group 1247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1246",
    "data-name": "Group 1246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M253.876,136.713a10.88,10.88,0,0,1,.8-3.9,26.386,26.386,0,0,1,12.124-14.5,10.923,10.923,0,0,1,3.691-1.479,37.482,37.482,0,0,1-3.358,2.043,30.279,30.279,0,0,0-11.844,14.163A37.7,37.7,0,0,1,253.876,136.713Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1273",
    "data-name": "Group 1273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1249",
    "data-name": "Group 1249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M330.084,216.819s15.17,19.569,18.817,26.92S378.707,332.3,378.707,332.3l-11.345,4.768Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1250",
    "data-name": "Group 1250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M269.046,198.5v-9.808l55.119,17.921,14.769,23.635,11.38,33.009-31.908-47.951Z",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1251",
    "data-name": "Group 1251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M265.773,207.929s-23.387,27.976-22.88,46.163c.5,17.909,24.787,126.74,24.787,126.74l-5.88,19.449L255.433,465.1H387.927l-9.22-132.8c-1.471-.087-29.049-76.109-29.049-76.109l-30.819-42.8-50.754-18.286Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1252",
    "data-name": "Group 1252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M366.739,300.673s9.267-.367,14.106,1.793,8.934,1.08,12.357,7.776,7.42,9.72,8.262,19.873-10.123,33.66-17.363,36.963S366.739,300.673,366.739,300.673Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1253",
    "data-name": "Group 1253",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M263.091,299.75s54.169,50.846,61.062,55.709,7.911,35.614,16.4,36.2S376.544,371.9,376.544,371.9l-81.49-76.768Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1261",
    "data-name": "Group 1261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1254",
    "data-name": "Group 1254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M339.373,345.277s-11.781,15.077-13.13,18.855-2.659,6.29-1.219,7.55a3.674,3.674,0,0,0,4.13.863c1.921-.731,11.388-13.224,11.388-13.224s-12.558,17.914-13.129,21c-.575,3.107,1.889,4.588,4.767,4.048s8.362-8.636,8.362-8.636-7.771,9-6.132,10.525,3.528,1.709,5.687.63,7.646-8.187,7.646-8.187-3.778,4.049-1.709,5.038,2.249,1.1,4.048-.4,17.681-17.041,17.681-17.041l-10.035-6.853Z",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1256",
    "data-name": "Group 1256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1255",
    "data-name": "Group 1255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M344.2,354.488a21.253,21.253,0,0,1-1.847,2.526c-1.273,1.657-2.851,3.711-4.6,5.983-1.806,2.332-3.5,4.4-4.768,5.861a16.706,16.706,0,0,1-2.165,2.265,21.31,21.31,0,0,1,1.881-2.5l4.64-5.945c1.8-2.328,3.465-4.422,4.72-5.894A16.6,16.6,0,0,1,344.2,354.488Z",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1258",
    "data-name": "Group 1258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1257",
    "data-name": "Group 1257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M352.546,361.712a96.744,96.744,0,0,1-6.28,7.816,97.127,97.127,0,0,1-6.677,7.48,192.815,192.815,0,0,1,12.957-15.3Z",
    fill: "#ff9a6c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1260",
    "data-name": "Group 1260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1259",
    "data-name": "Group 1259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M359.237,366.238a97.062,97.062,0,0,1-6.581,7.574,96.8,96.8,0,0,1-6.967,7.223,193.59,193.59,0,0,1,13.548-14.8Z",
    fill: "#ff9a6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1262",
    "data-name": "Group 1262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M272.94,225.344c7.605-1.614,17.273-2.286,24.626,1.884l40.195,36.258s56.647,63.554,58.872,67.1,5.209,24.457-3.375,35.115-18.218,6.56-29.234,4.049C355.306,367.758,294.4,323,269.36,304.415a47.808,47.808,0,0,1-17.8-25.951,57.868,57.868,0,0,1-2.015-20.663",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1264",
    "data-name": "Group 1264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1263",
    "data-name": "Group 1263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M249.548,257.8s-.014.355-.067,1.044-.1,1.717-.118,3.064a58.213,58.213,0,0,0,1.18,11.708,61.386,61.386,0,0,0,2.2,8.216,46.8,46.8,0,0,0,4.384,9.1,48.279,48.279,0,0,0,7.275,9.027c2.91,2.918,6.532,5.372,10.2,8.116,14.755,10.869,32.348,23.782,52.16,37.727,4.957,3.48,10.057,7.019,15.312,10.565,5.262,3.53,10.648,7.135,16.34,10.433a43.063,43.063,0,0,0,4.386,2.249,12.684,12.684,0,0,0,2.35.7l2.441.593a67.835,67.835,0,0,0,9.893,1.957,16.732,16.732,0,0,0,9.811-1.788,20.114,20.114,0,0,0,7.254-7.128c2.887-5,3.951-10.806,4.143-16.434a53,53,0,0,0-.347-8.424q-.255-2.079-.687-4.114a13.063,13.063,0,0,0-1.348-3.829c-1.645-2.161-3.495-4.245-5.254-6.318l-5.319-6.144L375.291,306.2l-37.684-42.573.015.016L297.483,227.32l.022.016a25.686,25.686,0,0,0-10.294-3.005,43.338,43.338,0,0,0-7.877.071c-2.117.205-3.713.475-4.782.656l-1.205.222c-.27.048-.407.064-.407.064s.536-.134,1.6-.351,2.661-.494,4.781-.72a42.684,42.684,0,0,1,7.906-.132,25.809,25.809,0,0,1,10.4,2.979l.011.006.011.01,40.25,36.2.008.007.008.009c11.27,12.631,24.018,26.954,37.745,42.522l10.457,11.916,5.326,6.144c1.773,2.091,3.587,4.121,5.3,6.371a7,7,0,0,1,.51.954c.139.33.237.668.358,1,.228.67.377,1.356.552,2.039q.442,2.063.7,4.165a53.532,53.532,0,0,1,.353,8.5c-.2,5.683-1.26,11.563-4.216,16.685a20.616,20.616,0,0,1-7.451,7.316,17.252,17.252,0,0,1-10.105,1.847,68.191,68.191,0,0,1-9.972-1.973l-2.435-.593a13.324,13.324,0,0,1-2.427-.729,43.425,43.425,0,0,1-4.445-2.28c-5.716-3.317-11.1-6.926-16.365-10.464-5.255-3.553-10.354-7.1-15.309-10.584-19.8-13.972-37.375-26.916-52.1-37.824-3.653-2.747-7.287-5.223-10.214-8.175a48.508,48.508,0,0,1-7.291-9.11,46.872,46.872,0,0,1-4.37-9.167,60.95,60.95,0,0,1-2.164-8.26,56.647,56.647,0,0,1-1.086-11.747A34.726,34.726,0,0,1,249.548,257.8Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1267",
    "data-name": "Group 1267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1266",
    "data-name": "Group 1266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M351.451,260.853a1.1,1.1,0,0,1-.228-.147l-.64-.474c-.548-.435-1.4-1.022-2.406-1.895-2.065-1.68-4.9-4.289-8.29-7.622s-7.31-7.415-11.764-11.837c-2.244-2.193-4.6-4.5-7.167-6.741a74.09,74.09,0,0,0-8.3-6.49c-1.214-.879-2.536-1.549-3.771-2.3l-.172-.1.042-.182q.311-1.367.612-2.689l.175.3-30.778-9.689-9.11-2.923-2.449-.811-.631-.222a.115.115,0,1,1,.015-.047l.645.177,2.476.725,9.157,2.773,30.829,9.525.227.07-.053.233q-.3,1.32-.609,2.69l-.131-.286c1.249.759,2.59,1.439,3.814,2.325a73.569,73.569,0,0,1,8.349,6.541c2.577,2.259,4.929,4.577,7.168,6.783,4.443,4.449,8.331,8.557,11.686,11.917s6.142,6.005,8.161,7.728c.981.9,1.813,1.506,2.34,1.967l.607.515A1.048,1.048,0,0,1,351.451,260.853Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1269",
    "data-name": "Group 1269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1268",
    "data-name": "Group 1268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M371.343,301.788a14.9,14.9,0,0,1-1.13-2.045L367.319,294c-2.419-4.864-5.722-11.6-9.337-19.06s-6.859-14.228-9.179-19.139c-1.128-2.415-2.05-4.391-2.722-5.829-.292-.652-.528-1.181-.715-1.6a2.7,2.7,0,0,1-.217-.572,2.726,2.726,0,0,1,.312.527l.8,1.554,2.87,5.757c2.411,4.935,5.691,11.651,9.317,19.072l9.2,19.126,2.745,5.817C371.031,301.021,371.387,301.821,371.343,301.788Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1271",
    "data-name": "Group 1271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1270",
    "data-name": "Group 1270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M277.707,411.492a2.635,2.635,0,0,1,.361.013l1.033.075,3.955.323,14.621,1.261,49.291,4.4-.273.317c-1.023-4.126-2.094-8.442-3.184-12.84-.5-2.016-.994-4.014-1.476-5.963l.222.2-55.193-6.4.169-.087c-3.241,5.744-5.738,10.378-7.368,13.6-.814,1.612-1.409,2.874-1.762,3.746a7.074,7.074,0,0,0-.347,1,1.831,1.831,0,0,0-.049.356,2.676,2.676,0,0,1,.306-1.4c.326-.889.895-2.166,1.683-3.794,1.581-3.255,4.033-7.916,7.237-13.687l.055-.1.115.013,55.213,6.231.179.021.044.175,1.477,5.962c1.089,4.4,2.157,8.716,3.178,12.843l.087.351-.36-.033-49.415-4.622-14.562-1.407-3.9-.4-1-.111A2.046,2.046,0,0,1,277.707,411.492Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1272",
    "data-name": "Group 1272",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M279.5,411.656l2.367,6.165,65.074,3.882v-3.882Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1",
    "data-name": "Character 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1444",
    "data-name": "Group 1444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1423",
    "data-name": "Group 1423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1274",
    "data-name": "Group 1274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M190.028,101.561c-.2-3.478-3.09-6.395-6.413-7.442s-6.955-.517-10.261.58c-7.21,2.391-13.27,7.3-19.153,12.1-9.129,7.456-18,17.688-21.483,28.947-2.626,8.48-3.386,14.02-.689,23.036,2.386,7.976,4.275,15.713,3.8,22.384-.749,10.549-2.029,13.031-4.739,23.382-1.7,6.476,4.075,23.4,4.075,23.4l36.49-13.958c13.027-6.123,41.069-17.545,41.069-17.545Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1388",
    "data-name": "Group 1388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1387",
    "data-name": "Group 1387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1386",
    "data-name": "Group 1386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1384",
    "data-name": "Group 1384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1383",
    "data-name": "Group 1383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1382",
    "data-name": "Group 1382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1359",
    "data-name": "Group 1359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    "data-name": "Group 1358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1357",
    "data-name": "Group 1357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1285",
    "data-name": "Group 1285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    "data-name": "Group 1284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1283",
    "data-name": "Group 1283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1282",
    "data-name": "Group 1282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1281",
    "data-name": "Group 1281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1280",
    "data-name": "Group 1280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1279",
    "data-name": "Group 1279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1278",
    "data-name": "Group 1278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1277",
    "data-name": "Group 1277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1276",
    "data-name": "Group 1276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1275",
    "data-name": "Group 1275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M169.511,225.286c.056-8.874.145-15.051.139-14.987,0,0-15.93-3.676-19.14-26.4a225.237,225.237,0,0,1-1.218-44.359c1.09-13.582,10.385-30.11,23.909-28.443l42.12,11.419c4.109.5,5.483,4.008,5.331,8.145l.308,1.944-3.086,64.873L219.2,225.07c-.539,12.327-12.737,23.536-25.063,24.1h0A23.522,23.522,0,0,1,169.511,225.286Z",
    fill: "#b56760"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1309",
    "data-name": "Group 1309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1296",
    "data-name": "Group 1296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1295",
    "data-name": "Group 1295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1294",
    "data-name": "Group 1294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1293",
    "data-name": "Group 1293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1292",
    "data-name": "Group 1292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1291",
    "data-name": "Group 1291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1290",
    "data-name": "Group 1290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1289",
    "data-name": "Group 1289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1288",
    "data-name": "Group 1288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1287",
    "data-name": "Group 1287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1286",
    "data-name": "Group 1286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M158.83,157.63a2.907,2.907,0,0,0,2.752,2.981,2.78,2.78,0,0,0,3.041-2.569,2.907,2.907,0,0,0-2.749-2.982A2.781,2.781,0,0,0,158.83,157.63Z",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1308",
    "data-name": "Group 1308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1307",
    "data-name": "Group 1307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1306",
    "data-name": "Group 1306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1305",
    "data-name": "Group 1305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1304",
    "data-name": "Group 1304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1303",
    "data-name": "Group 1303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1302",
    "data-name": "Group 1302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1301",
    "data-name": "Group 1301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1300",
    "data-name": "Group 1300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1299",
    "data-name": "Group 1299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1298",
    "data-name": "Group 1298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1297",
    "data-name": "Group 1297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M155.007,149.756c.353.385,2.584-1.207,5.711-1.145,3.126.017,5.393,1.665,5.739,1.289.17-.167-.186-.858-1.173-1.6a7.976,7.976,0,0,0-4.586-1.5,7.659,7.659,0,0,0-4.554,1.384C155.17,148.9,154.832,149.583,155.007,149.756Z",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    "data-name": "Group 1333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1320",
    "data-name": "Group 1320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1319",
    "data-name": "Group 1319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1318",
    "data-name": "Group 1318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    "data-name": "Group 1317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1316",
    "data-name": "Group 1316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1315",
    "data-name": "Group 1315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1314",
    "data-name": "Group 1314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1313",
    "data-name": "Group 1313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1312",
    "data-name": "Group 1312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1311",
    "data-name": "Group 1311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1310",
    "data-name": "Group 1310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M188.1,157.286a2.907,2.907,0,0,0,2.752,2.981,2.781,2.781,0,0,0,3.041-2.57,2.909,2.909,0,0,0-2.75-2.982A2.781,2.781,0,0,0,188.1,157.286Z",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    "data-name": "Group 1332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1330",
    "data-name": "Group 1330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1329",
    "data-name": "Group 1329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1328",
    "data-name": "Group 1328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1327",
    "data-name": "Group 1327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1326",
    "data-name": "Group 1326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    "data-name": "Group 1325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1324",
    "data-name": "Group 1324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1323",
    "data-name": "Group 1323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1322",
    "data-name": "Group 1322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1321",
    "data-name": "Group 1321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M185.005,149.667c.355.385,2.587-1.207,5.713-1.144,3.124.016,5.393,1.665,5.738,1.288.169-.167-.182-.857-1.173-1.6a7.975,7.975,0,0,0-4.585-1.5,7.667,7.667,0,0,0-4.555,1.384C185.171,148.814,184.831,149.494,185.005,149.667Z",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1345",
    "data-name": "Group 1345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    "data-name": "Group 1344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    "data-name": "Group 1343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1342",
    "data-name": "Group 1342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1341",
    "data-name": "Group 1341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1340",
    "data-name": "Group 1340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1339",
    "data-name": "Group 1339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1338",
    "data-name": "Group 1338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    "data-name": "Group 1337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    "data-name": "Group 1336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    "data-name": "Group 1335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1334",
    "data-name": "Group 1334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M172.447,173.323c.018-.178-1.921-.547-5.065-1-.8-.1-1.55-.268-1.675-.815a4.061,4.061,0,0,1,.573-2.359q1.176-2.88,2.467-6.041c3.428-8.6,5.925-15.682,5.578-15.817s-3.41,6.728-6.838,15.331q-1.239,3.183-2.368,6.079a4.625,4.625,0,0,0-.468,3.128,2,2,0,0,0,1.293,1.19,5.363,5.363,0,0,0,1.353.212C170.465,173.452,172.432,173.5,172.447,173.323Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1356",
    "data-name": "Group 1356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1355",
    "data-name": "Group 1355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1354",
    "data-name": "Group 1354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1353",
    "data-name": "Group 1353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    "data-name": "Group 1352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1351",
    "data-name": "Group 1351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1350",
    "data-name": "Group 1350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1349",
    "data-name": "Group 1349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1348",
    "data-name": "Group 1348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1347",
    "data-name": "Group 1347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1346",
    "data-name": "Group 1346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M169.65,210.3a57.673,57.673,0,0,0,30.492-7.576s-7.931,15.865-30.578,13.355Z",
    fill: "#8a4a43"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1370",
    "data-name": "Group 1370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1369",
    "data-name": "Group 1369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1368",
    "data-name": "Group 1368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1367",
    "data-name": "Group 1367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1366",
    "data-name": "Group 1366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1365",
    "data-name": "Group 1365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1364",
    "data-name": "Group 1364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1363",
    "data-name": "Group 1363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1362",
    "data-name": "Group 1362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1361",
    "data-name": "Group 1361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1360",
    "data-name": "Group 1360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M184,138.607c.366.828,3.455.213,7.146.4,3.7.117,6.722.987,7.156.192.192-.379-.377-1.142-1.627-1.882a12.443,12.443,0,0,0-10.9-.453C184.471,137.5,183.84,138.214,184,138.607Z",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1381",
    "data-name": "Group 1381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1380",
    "data-name": "Group 1380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1379",
    "data-name": "Group 1379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1378",
    "data-name": "Group 1378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1377",
    "data-name": "Group 1377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1376",
    "data-name": "Group 1376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1375",
    "data-name": "Group 1375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1374",
    "data-name": "Group 1374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1373",
    "data-name": "Group 1373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1372",
    "data-name": "Group 1372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1371",
    "data-name": "Group 1371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M154.128,139.991c.639.721,3.2.028,6.266.046,3.066-.073,5.653.574,6.264-.158.267-.357-.129-1.075-1.252-1.767a9.873,9.873,0,0,0-5.073-1.252,9.727,9.727,0,0,0-5.022,1.342C154.215,138.914,153.847,139.639,154.128,139.991Z",
    fill: "#263238"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1389",
    "data-name": "Group 1389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M173.189,181.032a6.531,6.531,0,0,1,6.065-2.776h0c.076,0,.151,0,.219,0a3.263,3.263,0,0,1,2.4,5.472,5.733,5.733,0,0,1-3.009,1.834,5.457,5.457,0,0,1-4.449-.5A3.252,3.252,0,0,1,173.189,181.032Z",
    fill: "#8a4a43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1390",
    "data-name": "Group 1390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M181.942,176.293c-.155-.025-.346.79-.926,1.953a9.646,9.646,0,0,1-7.855,5.462c-1.292.138-2.123.034-2.153.188-.032.117.772.486,2.181.532a8.8,8.8,0,0,0,8.492-5.9C182.129,177.186,182.063,176.3,181.942,176.293Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1391",
    "data-name": "Group 1391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M148.715,165.708l-4.7-19c-4.216-5.821-.924-15.315,2.067-21.851s8.691-11.54,15.034-14.92,13.353-5.288,20.332-7.01A38.919,38.919,0,0,1,164.7,124.064s-11.574,7.906-13.66,17.233C148.76,151.49,148.715,165.708,148.715,165.708Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    "data-name": "Group 1392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M175.074,114.929,208.141,134.8a107.613,107.613,0,0,0,7.047,29.735c6.1-5.218,9.871,4.838,11.7-2.892.095-.4-1.679,16.217-8.072,16.736l-1.052,18.066,31.539-7.754s-1.7-21.906-7.078-35.194c-3.348-8.265-5.118-15.192-8.423-23.474-2.5-6.268-6.942-15.635-10.281-20.094-7.169-9.577-33.694-10-33.694-10-11.7,2.761-3.822,1.445-13.666,8.335L172.8,117.3",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1403",
    "data-name": "Group 1403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1402",
    "data-name": "Group 1402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1401",
    "data-name": "Group 1401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1400",
    "data-name": "Group 1400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1399",
    "data-name": "Group 1399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1398",
    "data-name": "Group 1398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1397",
    "data-name": "Group 1397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1396",
    "data-name": "Group 1396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1395",
    "data-name": "Group 1395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1394",
    "data-name": "Group 1394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1393",
    "data-name": "Group 1393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M215.183,164.413c-.023-4.776,5.087-8.245,9.428-6.09,2.383,1.184,4.3,3.72,4.366,8.788.185,13.515-13.681,10.927-13.71,10.54C215.249,177.411,215.21,170.005,215.183,164.413Z",
    fill: "#b56760"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1415",
    "data-name": "Group 1415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1414",
    "data-name": "Group 1414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1413",
    "data-name": "Group 1413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1412",
    "data-name": "Group 1412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1411",
    "data-name": "Group 1411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1410",
    "data-name": "Group 1410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1409",
    "data-name": "Group 1409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1408",
    "data-name": "Group 1408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1407",
    "data-name": "Group 1407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1406",
    "data-name": "Group 1406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1405",
    "data-name": "Group 1405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1404",
    "data-name": "Group 1404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M219.4,172.47c.061-.044.243.161.651.338a2.446,2.446,0,0,0,1.794.01c1.448-.545,2.642-2.829,2.675-5.266a7.638,7.638,0,0,0-.717-3.361,2.743,2.743,0,0,0-1.83-1.781,1.229,1.229,0,0,0-1.407.665c-.18.381-.088.65-.161.674-.038.034-.3-.222-.2-.782a1.509,1.509,0,0,1,.531-.855,1.842,1.842,0,0,1,1.322-.363,3.354,3.354,0,0,1,2.535,2.059,7.872,7.872,0,0,1,.884,3.755c-.051,2.725-1.437,5.293-3.42,5.887a2.61,2.61,0,0,1-2.2-.326C219.433,172.8,219.356,172.495,219.4,172.47Z",
    fill: "#8a4a43"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1417",
    "data-name": "Group 1417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1416",
    "data-name": "Group 1416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M190.837,99.9a3.444,3.444,0,0,1-.57.813c-.411.487-1.031,1.172-1.836,1.975-1.6,1.615-3.912,3.739-6.471,6.07s-4.863,4.451-6.5,6.021-2.605,2.579-2.665,2.526a3.651,3.651,0,0,1,.593-.793c.4-.493,1.027-1.171,1.812-1.994,1.572-1.642,3.843-3.814,6.4-6.145l6.567-5.95C189.856,100.9,190.778,99.853,190.837,99.9Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1419",
    "data-name": "Group 1419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1418",
    "data-name": "Group 1418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M154.053,111.352a5.991,5.991,0,0,1,.879-1.043,26.205,26.205,0,0,1,2.748-2.508,30.377,30.377,0,0,1,10.926-5.5,12.031,12.031,0,0,1,6.776-.088,6.693,6.693,0,0,1,4.206,3.553,5.2,5.2,0,0,1,.192,3.721,3.746,3.746,0,0,1-.458.915c-.143.186-.224.277-.238.267a9.966,9.966,0,0,0,.5-1.242,5.181,5.181,0,0,0-.335-3.511,6.391,6.391,0,0,0-4.014-3.246,11.8,11.8,0,0,0-6.5.135,32.176,32.176,0,0,0-10.832,5.291C155.417,109.966,154.125,111.424,154.053,111.352Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1421",
    "data-name": "Group 1421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1420",
    "data-name": "Group 1420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M146.485,124.948a6.257,6.257,0,0,1,.865-.972c.583-.6,1.436-1.457,2.52-2.487a47.8,47.8,0,0,1,9.28-7.116,19.679,19.679,0,0,1,6.043-2.335,7.7,7.7,0,0,1,5.223.786,5.642,5.642,0,0,1,2.4,2.638,4.044,4.044,0,0,1,.251.944c.023.223.025.339.007.341-.05.009-.093-.462-.443-1.2a5.7,5.7,0,0,0-2.4-2.4,7.452,7.452,0,0,0-4.96-.634,20,20,0,0,0-5.871,2.317,53.923,53.923,0,0,0-9.285,6.932l-2.628,2.363A6.281,6.281,0,0,1,146.485,124.948Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M225.654,178.968a4.725,4.725,0,1,1-4.883-4.561A4.725,4.725,0,0,1,225.654,178.968Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1443",
    "data-name": "Group 1443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1424",
    "data-name": "Group 1424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M139.025,314.046c-1.134.756-13.6,3.779-16.625,11.713s-19.064,24.065-7.454,39.8l24.079-13.355Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M114.939,365.6l-.013-.018a20.694,20.694,0,0,1-3.932-9.125,21.9,21.9,0,0,1,.513-8.838c1.431-5.712,4.68-11.039,7.289-15.32a45.715,45.715,0,0,0,3.581-6.544c2.474-6.494,11.257-9.7,15.008-11.069a12.224,12.224,0,0,0,1.626-.655l.039-.027v38.224l-.013.007ZM139,314.091a13.807,13.807,0,0,1-1.6.637c-3.745,1.366-12.513,4.567-14.979,11.04a45.7,45.7,0,0,1-3.584,6.553c-2.608,4.277-5.855,9.6-7.283,15.3a21.845,21.845,0,0,0-.513,8.82,20.677,20.677,0,0,0,3.91,9.086L139,352.194Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1425",
    "data-name": "Group 1425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M166.8,248.276l1.973-27.224,49.559-20.678,1.76,10.159L186.329,227.71Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1426",
    "data-name": "Group 1426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M220.09,204.537s-30.361,12.282-43.827,24.281c-12.666,11.286-39,55.761-41.822,67.89s-2.268,45.685-2.268,45.685-.068,34.618-.068,35.464-21.72,56.7-17.771,87.158H238.162s3.666-42.874-4.8-59.516-8.744-13.257-8.744-13.257,5.078-5.641,4.513-10.718a21.891,21.891,0,0,0-3.666-9.308l21.719-67.7s2.256-34.131-3.667-56.978c-5.553-21.419-7.62-20.208-14.564-27.057-.149-.147.093.188,0,0l-6.311-5.178Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1430",
    "data-name": "Group 1430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1427",
    "data-name": "Group 1427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M139.025,411.492c-.389-1.461,9.376-18.792,9.376-18.792l55.966,9.4,3.895,15.726Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1429",
    "data-name": "Group 1429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1428",
    "data-name": "Group 1428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M139.025,411.492a2.65,2.65,0,0,1,.362.013l1.034.075,3.962.323,14.634,1.262,49.269,4.4-.274.318-2.945-11.877c-.322-1.3-.642-2.593-.952-3.848l.209.194-55.952-9.481.18-.086c-3.238,5.737-5.736,10.372-7.367,13.6-.814,1.613-1.409,2.875-1.763,3.748a7.115,7.115,0,0,0-.348,1.007,1.834,1.834,0,0,0-.049.356,2.669,2.669,0,0,1,.306-1.4c.326-.89.9-2.168,1.685-3.8,1.581-3.256,4.033-7.917,7.234-13.683l.059-.106.121.02,55.98,9.311.168.028.042.166c.31,1.255.631,2.548.953,3.848,1.007,4.069,2,8.066,2.939,11.879l.087.352-.36-.034-49.394-4.619-14.576-1.409-3.909-.4-1-.112A2.05,2.05,0,0,1,139.025,411.492Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1432",
    "data-name": "Group 1432",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M127,384.6l1.25,10.139c8.925,6.32,21.547,5.115,31.091-.225s16.63-14.106,23.177-22.866c19.844-26.551,37.133-55.224,48.925-86.2C200.686,322.381,158.065,347.92,127,384.6Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1436",
    "data-name": "Group 1436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1433",
    "data-name": "Group 1433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M226.982,233.193c10.392,8.271,19.449,34.147,3.362,56.518,0,0-70.3,95.376-81.943,102.989s-27.314,3.134-31.792-8.06-2.687-21.942,3.582-29.554,47.464-80.152,47.464-80.152,9.4-33.625,25.4-43.385",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1435",
    "data-name": "Group 1435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1434",
    "data-name": "Group 1434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M193.06,231.549s-.24.179-.722.508c-.495.312-1.185.842-2.079,1.554a41.33,41.33,0,0,0-6.774,7.4c-5.181,7.067-11.058,18.623-15.664,33.974l-.007.022-.009.017c-9.043,15.915-20.327,35.721-33.463,57.952-3.31,5.543-6.7,11.257-10.36,17.01-.952,1.418-1.823,2.888-2.88,4.276-.508.712-1.026,1.4-1.551,2.073s-.98,1.413-1.432,2.146a27.947,27.947,0,0,0-2.212,4.7,28.96,28.96,0,0,0-1.24,5.105,29.939,29.939,0,0,0,.453,10.624c.2.879.4,1.756.686,2.617.237.874.569,1.719.88,2.573s.754,1.641,1.134,2.462l.743,1.139a6.957,6.957,0,0,0,.8,1.1,19.451,19.451,0,0,0,8.942,6.168,23.012,23.012,0,0,0,11.04.955,22.743,22.743,0,0,0,9.476-3.873,65.392,65.392,0,0,0,7.248-7.252c4.543-5.091,8.825-10.285,12.993-15.416,8.318-10.281,16.151-20.352,23.565-29.981s14.387-18.838,20.888-27.472l9.38-12.515q2.247-3.018,4.4-5.912c1.416-1.942,2.9-3.782,4.081-5.739a45.1,45.1,0,0,0,5.586-11.751q.408-1.491.806-2.941c.268-.965.362-1.954.548-2.906a45.223,45.223,0,0,0,.6-5.608,46.4,46.4,0,0,0-3.116-18.283,35.263,35.263,0,0,0-5.931-10.145c-.45-.5-.807-.985-1.184-1.332l-.946-.877c-.507-.472-.758-.725-.758-.725s.274.225.793.685l.967.861c.385.343.749.82,1.207,1.319a34.8,34.8,0,0,1,6.04,10.139,46.379,46.379,0,0,1,3.219,18.368,45.42,45.42,0,0,1-.578,5.648c-.184.96-.276,1.956-.543,2.929s-.531,1.962-.8,2.965a45.381,45.381,0,0,1-5.6,11.856c-1.2,1.983-2.667,3.82-4.08,5.767l-4.391,5.922q-4.5,6.03-9.357,12.534c-6.487,8.647-13.451,17.862-20.852,27.505s-15.232,19.719-23.55,30.01c-4.168,5.137-8.45,10.336-13,15.441-1.13,1.282-2.307,2.534-3.5,3.781a36.936,36.936,0,0,1-3.825,3.543,23.251,23.251,0,0,1-9.7,3.969,23.516,23.516,0,0,1-11.292-.978,19.971,19.971,0,0,1-9.177-6.336,7.446,7.446,0,0,1-.826-1.131l-.763-1.174c-.393-.843-.852-1.666-1.167-2.531s-.65-1.723-.891-2.61c-.284-.873-.5-1.764-.7-2.657a30.406,30.406,0,0,1-.454-10.8,29.35,29.35,0,0,1,1.267-5.2,28.44,28.44,0,0,1,2.257-4.793c.461-.747.934-1.489,1.462-2.186s1.062-1.385,1.555-2.076c1.034-1.354,1.915-2.835,2.862-4.243,3.655-5.738,7.053-11.448,10.368-16.984,13.159-22.21,24.482-42,33.571-57.881l-.016.039c4.664-15.385,10.6-26.932,15.844-33.993a40.424,40.424,0,0,1,6.864-7.358,23.61,23.61,0,0,1,2.113-1.52C192.8,231.7,193.06,231.549,193.06,231.549Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1437",
    "data-name": "Group 1437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M162.057,305.381s-1.809-4.736-5.423-5.362-10.612.039-10.612.039-3.082,2.318-3.053,5.5a22.894,22.894,0,0,0,.651,5.407s-2.534-3.411-5.861-.179-6.254,9.777-6.254,9.777-4.43,1.418-6.117,3.568a19.563,19.563,0,0,0-2.684,5.631,7.2,7.2,0,0,0-3.06,6.915,9.026,9.026,0,0,0,4.7,6.689s13.2,9.735,14.823,8.478,4.917-3.246.164-7.451-7.726-6.855-7.726-6.855l2.238-3.455s12.925,8.883,15,8.457,5.6-.5,4.156-3.686-13.536-12.49-13.536-12.49l1.435-4.985s13.968,9.465,16.263,7.95,4.333-2.221,2.011-5.338-12.42-10.572-12.42-10.572l4.135-3.86S160.637,311.215,162.057,305.381Z",
    fill: "#b56760"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1439",
    "data-name": "Group 1439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1438",
    "data-name": "Group 1438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M222.646,215.307a1.959,1.959,0,0,1-.347.107l-1.026.271c-.9.24-2.235.585-3.939,1.07a141.691,141.691,0,0,0-14.216,4.767c-1.468.589-2.993,1.241-4.548,1.988-.78.369-1.573.751-2.357,1.184-.392.214-.8.413-1.19.645-.373.252-.769.472-1.133.756a62.173,62.173,0,0,0-8.38,8.355c-5.477,6.331-11.066,13.666-16.794,21.454s-11.009,15.351-15.746,22.267c-2.366,3.459-4.592,6.762-6.645,9.872a79.861,79.861,0,0,0-5.311,8.872,100.214,100.214,0,0,0-5.567,13.906c-.542,1.686-.933,3.006-1.194,3.9l-.3,1.02a1.994,1.994,0,0,1-.114.344,1.77,1.77,0,0,1,.063-.357c.061-.259.142-.6.245-1.034.229-.906.588-2.236,1.1-3.935a94.578,94.578,0,0,1,5.431-14.009,78.794,78.794,0,0,1,5.28-8.945c2.04-3.123,4.253-6.437,6.61-9.906,4.717-6.934,10-14.495,15.722-22.3s11.338-15.128,16.853-21.462a61.915,61.915,0,0,1,8.486-8.388c.373-.287.789-.518,1.176-.775.4-.236.809-.432,1.207-.646.793-.432,1.593-.812,2.38-1.179,1.569-.741,3.105-1.385,4.583-1.966a130.489,130.489,0,0,1,14.3-4.62c1.715-.456,3.057-.77,3.968-.977l1.039-.221A1.844,1.844,0,0,1,222.646,215.307Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1441",
    "data-name": "Group 1441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1440",
    "data-name": "Group 1440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M214.787,386.237a11.527,11.527,0,0,1-1.547-.874c-.983-.584-2.37-1.49-4.046-2.663a94.454,94.454,0,0,1-22.574-22.454c-1.182-1.67-2.1-3.051-2.685-4.031a11.629,11.629,0,0,1-.882-1.542A11.653,11.653,0,0,1,184.1,356.1c.64.944,1.6,2.29,2.812,3.926A105.957,105.957,0,0,0,209.409,382.4c1.643,1.207,2.994,2.157,3.941,2.792A11.656,11.656,0,0,1,214.787,386.237Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1442",
    "data-name": "Group 1442",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M140.821,411.656l1.693,6.165,63.376-.217Z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoweare);
export default __webpack_public_path__ + "static/media/whoweare.b2e93f21a37b03cdabf2948270c9d30f.svg";
export { ForwardRef as ReactComponent };